import services from '@/http';
import { user } from '@/http';

export const ActionSendEmailOrSmsText = (_, payload) => {
    user.sendSmsOrEmail.data = payload;

    return services.http.request(user.sendSmsOrEmail)
        .then(response => {
            return response;
        })
        .catch((err) => {
            return err;
        });
}

export const ActionContatoWhatsapp = ( _, payload) => {
    user.contatoWhatsapp.data = payload;
    return services.http.request(user.contatoWhatsapp)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionGetDebtsBoticarioAndEudora = (_, payload) => {
    user.getDebtsBoticarioAndEudora.data = payload;
    return services.http.request(user.getDebtsBoticarioAndEudora)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionViewOffersBoticarioAndEudora = (_, payload) => {
    user.viewOffersBoticarioAndEudora.data = payload;
    return services.http.request(user.viewOffersBoticarioAndEudora)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionPaymentActionBoticarioAndEudora = (_, payload) => {
    user.paymentActionBoticarioAndEudora.data = payload;
    return services.http.request(user.paymentActionBoticarioAndEudora)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionSetAgreementBoticarioAndEudora = (_, payload) => {
    user.agreementBoticarioAndEudora.data = payload;
    return services.http.request(user.agreementBoticarioAndEudora)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionSendAgreementEmailOrWhatsappBoticario = (_, payload) => {
    user.sendEmailOrWhatsapp.data = payload;
    return services.http.request(user.sendEmailOrWhatsapp)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}
